import { PaymentStatus } from "@/components/admin/PaymentStatus";

export default function PaymentsPage() {
  return (
    <div className="container mx-auto py-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Verificação de Pagamentos</h1>
        <p className="text-muted-foreground">
          Verifique e gerencie os pagamentos dos usuários do sistema.
        </p>
      </div>
      <PaymentStatus />
    </div>
  );
}
